import React from "react";
import { Container } from "react-bootstrap";
import SEO from "../SEO/SEO";
import './EnviosYDevoluciones.css'

const dataItems = [
    "Datos enviados voluntariamente por formularios o canales de contacto.",
    "Nombre, telefono, correo o mensaje si decidis compartirlos.",
    "Informacion tecnica de navegacion y estadisticas de uso del sitio.",
    "Consultas iniciadas por WhatsApp, mapas o redes sociales externas.",
];

const useItems = [
    "Responder consultas sobre productos, ubicacion o atencion.",
    "Mejorar el contenido, la navegacion y la experiencia del catalogo.",
    "Analizar el uso de las secciones publicas del sitio.",
    "Comunicar novedades solo cuando corresponda y sea permitido.",
];

const cookieItems = [
    "Cookies tecnicas para funcionamiento basico.",
    "Cookies de analitica para entender la navegacion.",
    "Tecnologias de terceros vinculadas a mapas, redes sociales o herramientas externas.",
];

const PoliticaPrivacidadYCookies = () => {
    return (
        <main className="legal-page">
            <SEO
                title="Privacidad y cookies | Whisky And Co"
                description="Politica de privacidad y cookies de whiskyandco.com.ar."
                canonicalPath="/politica-de-privacidad"
            />

            <Container className="legal-shell">
                <section className="legal-hero">
                    <span className="legal-kicker">Privacidad clara</span>
                    <h1>Politica de Privacidad y Cookies</h1>
                    <p>
                        Cuidamos la informacion de quienes visitan whiskyandco.com.ar. Esta web es institucional y de catalogo: no procesa compras, pagos ni cuentas de usuario.
                    </p>
                </section>

                <section className="legal-layout">
                    <aside className="legal-summary">
                        <span className="legal-summary-label">Ultima actualizacion</span>
                        <p>3 de junio de 2026</p>
                        <span className="legal-summary-label">Derechos</span>
                        <p>Podes solicitar acceso, rectificacion, actualizacion o supresion de tus datos conforme a la Ley 25.326.</p>
                    </aside>

                    <div className="legal-content">
                        <article className="legal-card">
                            <span className="legal-card-number">01</span>
                            <h2>Datos que podemos recopilar</h2>
                            <ul className="legal-list">
                                {dataItems.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                        </article>

                        <article className="legal-card">
                            <span className="legal-card-number">02</span>
                            <h2>Para que usamos la informacion</h2>
                            <ul className="legal-list">
                                {useItems.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                        </article>

                        <article className="legal-card">
                            <span className="legal-card-number">03</span>
                            <h2>Servicios externos</h2>
                            <p>
                                Podemos usar servicios tecnicos necesarios para operar y medir el sitio, como hosting, analitica, mapas, WhatsApp o redes sociales. Estos servicios pueden tratar datos conforme a sus propias politicas.
                            </p>
                            <p>No vendemos informacion personal a terceros.</p>
                        </article>

                        <article className="legal-card">
                            <span className="legal-card-number">04</span>
                            <h2>Cookies</h2>
                            <ul className="legal-list">
                                {cookieItems.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                            <p>
                                Podes bloquear o eliminar cookies desde tu navegador. Algunas funciones del sitio podrian verse afectadas.
                            </p>
                        </article>

                        <article className="legal-card">
                            <span className="legal-card-number">05</span>
                            <h2>Contacto por privacidad</h2>
                            <p>
                                Para ejercer tus derechos o realizar consultas, comunicate con Whisky&Co al <strong>+54 351 529-5096</strong> o mediante nuestros canales de contacto.
                            </p>
                        </article>
                    </div>
                </section>
            </Container>
        </main>
    );
};

export default PoliticaPrivacidadYCookies;
